import ArtworkAgreement from "@/pages/information/artwork-agreement";
import BuyerProtectionPage from "@/pages/information/buyer-protection";
import CertificateOfOwnershipPage from "@/pages/information/certificate-of-ownership";
import CollaborationAuctionAgreement from "@/pages/information/collaboration-auction-agreement";
import CookiePolicy from "@/pages/information/cookies";
import GuidelinesUploadArtworks from "@/pages/information/guidelines-upload-artwork";
import LimitedEditionPolicies from "@/pages/information/limited-editions-policies";
import LimitedEditionsReturnRefundPolicyPage from "@/pages/information/limited-editions-return-refund-policy";
import OriginalsReturnRefundPolicyPage from "@/pages/information/originals-return-refund-policy";
import PrivacyPolicy from "@/pages/information/privacy-policy";
import Terms from "@/pages/information/terms";

const InformationPagesRoutes = [
  {
    path: '/terms',
    element: <Terms/>
  },

  {
    path: '/privacy-policy',
    element: <PrivacyPolicy/>
  },

  {
    path: '/cookie-policy',
    element: <CookiePolicy/>
  },

  {
    path: '/guidelines-upload-artworks',
    element: <GuidelinesUploadArtworks/>
  },

  {
    path: '/limited-edition-policies',
    element: <LimitedEditionPolicies/>
  },

  {
    path: '/limited-editions-return-and-refund-policy',
    element: <LimitedEditionsReturnRefundPolicyPage/>
  },

  {
    path: '/return-and-refund-policy',
    element: <OriginalsReturnRefundPolicyPage/>
  },

  {
    path: '/artwork-agreement',
    element: <ArtworkAgreement/>
  },

  {
    path: '/collaboration-auction-agreement',
    element: <CollaborationAuctionAgreement/>
  },

  {
    path: '/certificate-of-ownership',
    element: <CertificateOfOwnershipPage/>
  },

  {
    path: '/buyer-protection',
    element: <BuyerProtectionPage/>
  },
  {
    path: '/guarantee',
    element: <BuyerProtectionPage/>
  }
];

export default InformationPagesRoutes;
